import { Component, OnInit } from '@angular/core';
import { DrawerItem } from '@progress/kendo-angular-layout';
import { UserService } from '../../../../modules/fwcore/services';
import { DashboardFrameComponent, LatestNewsComponent, LatestPublicationsComponent, StockChartComponent, WinsComponent } from '../../components';
import { IdeawordComponent } from '../../components/ideaword/ideaword.component';
import { AsklearnshareComponent } from '../../components/asklearnshare/asklearnshare.component';
import { SpotlightCarouselComponent } from '../../components/spotlight-carousel/spotlight-carousel.component';
import { PinnedTilesComponent } from '../../components/pinned-tiles/pinned-tiles.component';
import { SearchDashComponent } from '../../components/search-dash/search-dash.component';


@Component({
  selector: 'app-page-dashboard',
  standalone: true,
  imports: [
    DashboardFrameComponent, LatestNewsComponent, WinsComponent, LatestPublicationsComponent, SpotlightCarouselComponent, IdeawordComponent, AsklearnshareComponent, PinnedTilesComponent, SearchDashComponent
  ],
  providers: [

  ],
  templateUrl: './page-dashboard.component.html',
  styleUrl: './page-dashboard.component.scss'
})
export class PageDashboardComponent implements OnInit {

  constructor(protected userService: UserService) { //

  }

  ngOnInit() {
    this.userService.getCurrentRoles(true);
  }
}
